<template>
	<b-container>
		<b-row>
			<b-col cols lg="10" style="padding-bottom:20px;">
				<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
				<b-card bg-variant="light" style="margin-top: 15px;">
					<b-form>
						<h2 class="title">{{$lang.finnance.purchaseOrders.new}}</h2>
						<hr>
						<div style="margin-bottom: 10px;">
							<label for="purchaseOrder.provider" class="col-form-label">{{$lang.finnance.purchaseOrders.number}}</label>
							<b-input-group >
								<b-form-input v-model="purchaseOrder.orderNumber"
																required
																disabled
																:placeholder="$lang.finnance.purchaseOrders.number" />
							</b-input-group>
						</div>
						<div class="form-division">
							<label for="purchaseOrder.status">{{$lang.common.status}}</label>
							<v-select class="v-select-custom" v-model="purchaseOrder.status" :options="$store.getters.purchaseOrderStatuses" v-on:input="checkDates" :getOptionLabel="status => $lang.finnance.purchaseOrders.statuses[status.value]" style="background-color: #FFF;" :clearable="false" />
						</div>
						<b-row style="margin-bottom: 10px;">
							<b-col cols lg=3 >
								<label for="purchaseOrder.date">{{$lang.finnance.purchaseOrders.date}}</label>
								<date-pick v-model="purchaseOrder.date" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control', disabled: this.disabledDate }" ></date-pick>
							</b-col>
							<b-col cols lg=3 >
								<label for="purchaseOrder.date">{{$lang.finnance.purchaseOrders.dateDelivered}}</label>
								<date-pick v-model="purchaseOrder.dateDelivered" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control', disabled: this.disabledDateDelivered}" ></date-pick>
							</b-col>
							<b-col cols lg=3 >
								<label for="purchaseOrder.date">{{$lang.finnance.purchaseOrders.dateInvoiced}}</label>
								<date-pick v-model="purchaseOrder.dateInvoiced" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control', disabled: this.disabledDateInvoiced }" ></date-pick>
							</b-col>
							<b-col cols lg=3 >
								<label for="purchaseOrder.date">{{$lang.finnance.purchaseOrders.datePaid}}</label>
								<date-pick v-model="purchaseOrder.datePaid" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control', disabled: this.disabledDatePaid }" ></date-pick>
							</b-col>
						</b-row>
						<div class="form-division">
							<label for="purchaseOrder.costCenter">{{$lang.contract.costCenter}}</label>
							<v-select class="v-select-custom" v-model="purchaseOrder.costCenter" :options="$store.getters.costCenters" :getOptionLabel="costCenter => costCenter.name" style="background-color: #FFF;" :clearable="false" :disabled="purchaseOrder.id != undefined" />
						</div>
						<div class="form-division">
							<label for="purchaseOrder.provider">{{$lang.settings.providers.label}}</label>
							<v-select class="v-select-custom" v-model="purchaseOrder.provider" :options="$store.getters.providers" v-on:input="providerSelected" :getOptionLabel="provider => provider.name" style="background-color: #FFF;" :clearable="false" :disabled="purchaseOrder.id != undefined" />
						</div>
						<hr>
						<h4 class="title">{{$lang.settings.materials.title}}</h4>
						<b-button variant="info" class="title" value="Save" v-on:click="addNewLineItem" :disabled="purchaseOrder.provider.name == undefined">{{$lang.buttons.new}}</b-button>
						<div style="margin-top:25px;"></div>
						<b-row v-if="purchaseOrder.products.length == 0">
							<b-col><strong>{{$lang.finnance.purchaseOrders.noProducts}}</strong></b-col>
						</b-row>
						<b-row v-for="(material, index) in purchaseOrder.products" :key="index">
							<b-col lg="1">
								<div class="form-division" style="">
									#{{ index + 1 }}
									<b-button style="margin-top: 10px;" variant="danger" size="sm" @click="deleteElement(index)" class="mb-12 text-right"><font-awesome-icon icon="trash" /></b-button>
								</div>
							</b-col>
							<b-col lg="9">
								<div class="form-division">
									<label for="material.name">{{$lang.settings.providers.materials.name}}</label>
									<v-select class="v-select-custom" v-model="material.object" :options="purchaseOrder.provider.materials" @input="materialSelected(material, index)" label="name" style="background-color: #FFF;" :clearable="false" />
								</div>
							</b-col>
							<b-col lg="2">
								<label for="material.quantity">{{$lang.settings.providers.materials.quantity}}</label>
								<money v-model="material.quantity" v-bind="price" class="form-control" @blur="calculateTotals()"></money>
								<!-- <b-form-group :label="$lang.settings.providers.materials.quantity">
									<b-form-input v-model.number="material.quantity" type="number" @blur="calculateTotals()"
										:placeholder="$lang.settings.providers.materials.quantity" />
								</b-form-group> -->
							</b-col>
							<b-col lg=12 style="margin-bottom:10px;" class="text-right">
								<div v-if="material.quantity > 0">
									{{$lang.settings.providers.materials.price}}: {{formatNumber(material.price)}} * {{$lang.settings.providers.materials.quantity}}: {{formatNumber(material.quantity)}} = {{$lang.finnance.purchaseOrders.total}}: {{formatNumber(material.quantity * parseFloat(material.price))}}
								</div>
							</b-col>
						</b-row>
						<hr>
						<b-row>
							<b-col lg="4">
								<label for="purchaseOrder.date">{{$lang.finnance.purchaseOrders.subTotal}}</label>
								<money v-model="purchaseOrder.subTotalLabel" v-bind="price" class="form-control" disabled></money>
							</b-col>
							<b-col lg="4">
								<label for="purchaseOrder.date">{{$lang.finnance.purchaseOrders.taxRate}}</label>
								<money v-model="purchaseOrder.taxLabel" v-bind="price" class="form-control" disabled></money>
							</b-col>
							<b-col lg="4">
								<label for="purchaseOrder.date">{{$lang.finnance.purchaseOrders.total}}</label>
								<money v-model="purchaseOrder.totalLabel" v-bind="price" class="form-control" disabled></money>
							</b-col>
						</b-row>
					</b-form>
				</b-card>
			</b-col>
			<b-col cols lg="2" style="padding-top: 80px;">
				<b-card class="sideButtons" bg-variant="light">
					<b-button variant="primary" class="title" block value="Save" v-on:click="createPurchaseOrder"  >{{$lang.buttons.save}}</b-button>
					<b-button variant="danger"  class="title" block value="Cancel" @click="goToListScreen()">{{$lang.buttons.back}}</b-button>
					<hr>
					<b-button variant="info" class="title" block value="Print" v-on:click="printPurchaseOrder" :disabled="purchaseOrder.id == undefined">{{$lang.buttons.print}}</b-button>
					<b-button variant="info" class="title" block value="Invoice" v-on:click="invoiceOrder" :disabled="purchaseOrder.id == undefined">{{$lang.buttons.invoice}}</b-button>
				</b-card>
			</b-col>
        </b-row>
	</b-container>
</template>

<script>
import DatePick from 'vue-date-pick'
import { Money } from 'v-money'
import moment from 'moment'
import { jsPDF } from "jspdf"

const utils = require('../../../utils.js');

export default {
	data() {
		return {
			dateFormat: utils.dateFormat,
			disabledDate: true,
			disabledDateDelivered: true,
			disabledDateInvoiced: true,
			disabledDatePaid: true,
			purchaseOrder: {
				orderNumber: '',
				provider: {},
				costCenter: {},
				products: [],
				subTotal: 0,
				tax: 0,
				total: 0,
				subTotalLabel: 0,
				taxLabel: 0,
				totalLabel: 0,
				discount: 0,
				date: moment().format(utils.dateFormat),
				status: this.$store.getters.defaultPurchaseOrderStatus
			},
			price: {... utils.moneyConfig, precision: 2},
			breadcrumb: [{'text': this.$lang.modules.finnance,'to': '/'},{'text': this.$lang.finnance.purchaseOrders.title,'to': '/finnance/purchaseOrders'}, {'text': 'Orden de compra', 'href': '#'}],
		}
	},
	components: {
		Money,
		DatePick,
	},
	methods:{
		addNewLineItem() {
			console.log(this.purchaseOrder)
			this.purchaseOrder.products.push({})
		},
		providerSelected() {
			this.purchaseOrder.products = []
			// this.purchaseOrder.products = this.purchaseOrder.provider.materials
		},
		materialSelected(material, index) {
			this.purchaseOrder.products[index].code = material.object.code
			this.purchaseOrder.products[index].name = material.object.name
			this.purchaseOrder.products[index].price = material.object.price
			this.purchaseOrder.products[index].quantity = 0

			// this.calculateTotals()
		},
		calculateTotals() {
			this.purchaseOrder.products.forEach((element) => {
				this.purchaseOrder.subTotal += element.price * element.quantity
				this.purchaseOrder.tax = this.purchaseOrder.subTotal * 0.19
				this.purchaseOrder.total = this.purchaseOrder.subTotal + this.purchaseOrder.tax
			})

			this.purchaseOrder.subTotalLabel = this.purchaseOrder.subTotal
			this.purchaseOrder.taxLabel = this.purchaseOrder.tax
			this.purchaseOrder.totalLabel = this.purchaseOrder.total
		},
		deleteElement(index) {
			this.purchaseOrder.products.splice(index, 1)
		},
		createPurchaseOrder() {
			this.$store.dispatch('createPurchaseOrder', this.purchaseOrder).then((response) => {
				let purchaseOrderId = ''
				if (this.$route.name == 'PurchaseOrdersEdit') {
					purchaseOrderId = this.$route.params.purchaseOrderId
				} else {
					purchaseOrderId = response.id
					this.$router.push({name: 'PurchaseOrdersEdit', params: {purchaseOrderId: purchaseOrderId}})
				}
				this.$router.go()
			})
		},
		printPurchaseOrder() {

			let pdf = new jsPDF() // maxWidth = 210, maxHeight = 297
			let companyData = this.$store.getters.companyData;
			let currX = 0
			let currY = 0
			let datePrinted = moment().format(utils.dateFormat)
			let orderNumber = this.purchaseOrder.orderNumber.toString().padStart(5,'0');
			let providerRectangleHeight = 18;
			let providerName = pdf.splitTextToSize(this.purchaseOrder.provider.name, 70);
			let subTotal = 0
			let tax = 0
			let yIncrement = 8;
			// let page = 1;

			pdf.setFont("Courier", "Bold")
			// pdf.text("Hello world!", 10, 10);
			currX += 5
			currY += 10
			pdf.addImage(companyData.logo,'png', currX, currY+3, 45, 30) // w200 h197
			// pdf.roundedRect(10, 60, 190, 220, 5, 5, 'S')
			// HEADER START
			pdf.roundedRect(currX, currY, 140, 35, 2, 2, 'S')
			currX += 50
			currY += 13
			pdf.setFontSize(12)
			pdf.text(companyData.name, currX, currY, {'align': 'left', 'maxWidth': 90})
			pdf.setFont("Courier", "")
			pdf.setFontSize(10)
			currY += 6
			pdf.text('RUT: ' + companyData.id, currX, currY, {'align': 'left', 'maxWidth': 90})
			// currY += 6
			// pdf.text('Tlf: ', currX, currY, {'align': 'left', 'maxWidth': 90})
			currY += 6
			pdf.text('Dirección: ' + companyData.address1, currX, currY, {'align': 'left', 'maxWidth': 90})
			currX += 93
			currY = 16
			pdf.roundedRect(currX, 35, 57, 10, 2, 2, 'S')
			currX += 28
			pdf.setFont("Courier", "Bold")
			// pdf.setFontSize(12)
			// pdf.setFontStyle('bold');
			pdf.setFontSize(12)
			pdf.text('ORDEN DE COMPRA', currX, currY, {'align': 'center', 'maxWidth': 50})
			pdf.setFontSize(8)
			pdf.setFont("Courier", "")
			currX -= 25
			currY += 12
			pdf.text('Fecha de impresión: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.text(datePrinted, currX + 34, currY, {'align': 'left', 'maxWidth': 20})
			// pdf.text('Fecha de impresión: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			currY += 5
			pdf.text('Fecha de emisión: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.text(this.purchaseOrder.date, currX + 34, currY, {'align': 'left', 'maxWidth': 20})

			pdf.setFontSize(12)
			currY += 8
			pdf.text('Número: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.setTextColor(204,0,0)
			pdf.setFont("Courier", "Bold")
			pdf.text(orderNumber, currX + 34, currY, {'align': 'left', 'maxWidth': 20})
			pdf.setTextColor(0,0,0)
			pdf.setFont("Courier", "")
			// END OF HEADER

			// PROVIDER INFO
			currX = 5
			currY += 7
			currY += 5
			currX += 3
			pdf.setFontSize(10)
			pdf.text('Proveedor: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.text(providerName, currX + 25, currY, {'align': 'left', 'maxWidth': 70})
			currX += 90
			pdf.text('RUT: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.text(this.purchaseOrder.provider.idNumber, currX + 40, currY, {'align': 'left', 'maxWidth': 65})

			currX = 8
			if (providerName.length > 1) {
				currY += (5 * providerName.length)
				providerRectangleHeight += 2.5 * providerName.length
			} else {
				currY += 5
			}

			pdf.text('Atención: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.text(this.purchaseOrder.provider.contactName, currX + 25, currY, {'align': 'left', 'maxWidth': 65})
			currX += 90
			pdf.text('Correo: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.text(this.purchaseOrder.provider.contactEmail, currX + 40, currY, {'align': 'left', 'maxWidth': 65})

			currX = 8
			currY += 5
			pdf.text('Obra: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.text(this.purchaseOrder.costCenter.name || '', currX + 25, currY, {'align': 'left', 'maxWidth': 65})
			currX += 90
			pdf.text('Encargado de obra: ', currX, currY, {'align': 'left', 'maxWidth': 50})
			pdf.text(this.purchaseOrder.costCenter.administrator, currX + 40, currY, {'align': 'left', 'maxWidth': 65})

			pdf.roundedRect(5, 48, 200, providerRectangleHeight, 2, 2, 'S')
			// END PROVIDER INFO

			// LINE ITEMS HEADER
			pdf.setFont("Courier", "Bold")
			currX = 5
			currY += 7
			pdf.roundedRect(currX, currY, 200, 9, 2, 2, 'S')
			currY += 5
			currX += 3
			pdf.text('Item', currX, currY, {'align': 'left', 'maxWidth': 15})
			currX += 15
			pdf.text('Descripcion', currX, currY, {'align': 'left', 'maxWidth': 80})
			currX += 80
			pdf.text('Unidad', currX, currY, {'align': 'center', 'maxWidth': 20})
			currX += 20
			pdf.text('Cantidad', currX, currY, {'align': 'center', 'maxWidth': 30})
			currX += 30
			pdf.text('Valor Unitario', currX, currY, {'align': 'center', 'maxWidth': 30})
			currX += 35
			pdf.text('Total', currX, currY, {'align': 'center', 'maxWidth': 40})
			// END LINE ITEMS HEADER

			currY += 5
			pdf.setFont("Courier", "")


			this.purchaseOrder.products.forEach((item, index) => {
				let amount = item.price * item.quantity;
				subTotal += amount;
				currY += yIncrement
				currX = 8
				pdf.text((index+1).toString(), currX, currY, {'align': 'left', 'maxWidth': 15})
				currX += 15
				let itemName = pdf.splitTextToSize(item.name, 75);
				if (itemName.length > 1) {
					yIncrement = 5 * itemName.length
				} else {
					yIncrement = 8
				}
				pdf.text(itemName, currX, currY, {'align': 'left', 'maxWidth': 75})
				currX += 80
				pdf.text(item.object.uom, currX, currY, {'align': 'center', 'maxWidth': 20})
				currX += 20
				pdf.text(utils.formatNumber(item.quantity), currX, currY, {'align': 'center', 'maxWidth': 20})
				currX += 30
				pdf.text(utils.formatNumber(item.price), currX, currY, {'align': 'center', 'maxWidth': 30})
				currX += 35
				pdf.text(utils.formatNumber(amount), currX, currY, {'align': 'center', 'maxWidth': 40})
				if (currY >= 240) {
					pdf.addPage();
					currX = 5
					currY = 10
				}
			})
			tax = subTotal * 0.19

			currX = 5
			currY = 245
			pdf.roundedRect(currX, currY, 100, 40, 2, 2, 'S')
			currX += 3
			currY += 5
			pdf.setFont("Courier", "Bold")
			pdf.text('Aprobado por: GUILLERMO PEREZ DE ORY', currX, currY, {'align': 'left', 'maxWidth': 95})
			currX += 8
			currY += 5
			pdf.addImage(companyData.signature,'png', currX, currY+3, 80, 20) // w200 h197
			pdf.setFont("Courier", "")

			currX = 107
			currY = 245
			pdf.roundedRect(currX, currY, 98, 40, 2, 2, 'S')
			currX = 157
			currY += 25
			pdf.text('SUBTOTAL', currX, currY, {'align': 'right','maxWidth': 35})
			currX = 197
			pdf.text(utils.formatNumber(subTotal), currX, currY, {'align': 'right','maxWidth': 40})
			currX = 157
			currY += 5
			pdf.text('19% I.V.A', currX, currY, {'align': 'right','maxWidth': 30})
			currX = 197
			pdf.text(utils.formatNumber(tax), currX, currY, {'align': 'right','maxWidth': 40})

			pdf.setFont("Courier", "Bold")
			currX = 157
			currY += 5
			pdf.text('TOTAL (CLP)', currX, currY, {'align': 'right','maxWidth': 30})
			currX = 197
			pdf.text(utils.formatNumber(subTotal + tax), currX, currY, {'align': 'right','maxWidth': 40})

			// let pageCount = pdf.internal.getNumberOfPages();
			// for(let i = 0; i < pageCount; i++) {
			// 	pdf.setFont("Courier", "")
			// 	pdf.setPage(i);
			// 	pdf.text("Página " + pdf.internal.getCurrentPageInfo().pageNumber + "/" + pageCount, 183, 290)
			// }

			// pdf.saveGraphicsState();
			// pdf.setGState(new pdf.GState({opacity: 0.2}));
			// pdf.setTextColor(204,0,0)
			// pdf.setFont("Courier", "Bold")
			// pdf.setFontSize(100)
			// pdf.text('ANULADO', 50, 220, {'angle': 45})
			// pdf.restoreGraphicsState();

			pdf.save("OC_" + this.purchaseOrder.provider.code + "_" + orderNumber + ".pdf");

		},
		invoiceOrder() {
			this.$router.push({name: 'InvoiceNew', params: {purchaseOrderId: this.$route.params.purchaseOrderId}})
		},
		checkDates() {
			this.disabledDate = true
			this.disabledDateDelivered = true
			this.disabledDateInvoiced = true
			this.disabledDatePaid = true

			if (this.purchaseOrder.status.value === 'open') {
				this.disabledDate = false
			}

			if (this.purchaseOrder.status.value === 'delivered') {
				this.disabledDateDelivered = false
			}

			if (this.purchaseOrder.status.value === 'invoiced') {
				this.disabledDateInvoiced = false
			}

			if (this.purchaseOrder.status.value === 'paid') {
				this.disabledDatePaid = false
			}
		},
		goToListScreen() {
			this.$router.push({name: 'PurchaseOrders'})
			// this.$router.go()
		},
		formatNumber: utils.formatNumber
	},
	created() {
		this.$Progress.start()
		this.$store.dispatch('fetchProviders')
		this.$store.dispatch('fetchCostCenters')
		this.$store.dispatch('fetchPurchaseOrderStatuses')

		if(this.$route.params.purchaseOrderId) {
			let purchaseOrderId = this.$route.params.purchaseOrderId
			this.$store.dispatch('fetchPurchaseOrder', { purchaseOrderId }).then( () => {
				this.purchaseOrder = this.$store.getters.purchaseOrder;
				this.calculateTotals()
			} )
		}


		this.$Progress.finish();
	},

}
</script>